export default "__VITE_ASSET__BrayOkDl__"